<template>
   <div id="inside" style="">
     
    <div class="container">
      <div class="row">
        <div class="">
        </div>
        <div class="btn-group btn-group-sm">
            <a
              href="/"
              class="btn btn-link d-flex flex-column justify-content-center text-secondary"
              ><i class="fa fa-home fa-fw fa-lg"></i
            ></a>
            <router-link
              to="/dashboard/vencimentoParcelas"
              ><a class="btn btn-link text-secondary">Vencimento</a>
            </router-link>
            <router-link
              to="#"
              ><a href="#" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Propostas</a>
            </router-link>
        </div>
        <div class="col-md-12">
            <h1>Propostas</h1>
            <p class="text-muted">Selecione a proposta desejada pra seu acordo.</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">

        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-4">
          <div class="card">
            <div class="card-body border-top-0">
              <div class="row">
                <div class="col-md-12 col-12">
                  <h6 class="float-right text-primary"><span class="badge badge-pill badge-secondary">10% de desconto</span></h6>
                  <h5 class="">Proposta 1 </h5>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-6">
                  <p class="text-info mb-1">Valor de entrada:</p>
                  <h6 class="mb-3">R$ 1.000,00 </h6>
                </div>
                <div class="col-lg-6 col-6">
                  <p class="text-info mb-1">+ 12 parcelas de</p>
                  <h6 class="mb-3">R$ 230,00 </h6>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 d-flex justify-content-center mt-3">
                  <a @click="acordoFechado()" class="btn btn-secondary mr-1 mb-1 mx-auto py-2 px-4">Fechar este acordo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-4">
          <div class="card">
            <div class="card-body border-top-0">
              <div class="row">
                <div class="col-md-12 col-12">
                  <h6 class="float-right text-primary"><span class="badge badge-pill badge-secondary">6% de desconto</span></h6>
                  <h5>Proposta 2</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-lg-6">
                  <p class="text-info mb-1">Valor de entrada:</p>
                  <h6 class="mb-3">R$ 1.000,00 </h6>
                </div>
                <div class="col-6 col-lg-6">
                  <p class="text-info mb-1">+ 18 parcelas de</p>
                  <h6 class="mb-3">R$ 170,00 </h6>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 d-flex justify-content-center mt-3">
                  <a @click="acordoFechado()" class="btn btn-secondary mr-1 mb-1 mx-auto py-2 px-4">Fechar este acordo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-4">
          <div class="card">
            <div class="card-body border-top-0">
              <div class="row">
                <div class="col-md-12 col-12">
                  <h6 class="float-right text-primary"><span class="badge badge-pill badge-secondary">3% de desconto</span></h6>
                  <h5 class="">Proposta 3</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-6">
                  <p class="text-info mb-1">Valor de entrada:</p>
                  <h6 class="mb-3">R$ 1.000,00 </h6>
                </div>
                <div class="col-6 col-lg-6">
                  <p class="text-info mb-1">+ 24 parcelas de</p>
                  <h6 class="mb-3">R$ 110,00 </h6>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 d-flex justify-content-center mt-3">
                  <a @click="acordoFechado()" class="btn btn-secondary mr-1 mb-1 mx-auto py-2 px-4">Fechar este acordo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="row border-top border-info mx-2 pt-3">
        <div class="col-lg-6" style="">
          <a @click="voltarNegociar()" class="btn-link small">Voltar para Negociar</a>
          </div>
        <div class="col-md-6">
          <p class="mt-3 small text-info">Após fechar acordo você será levado à tela de vencimentos.</p>
        </div>
      </div>
          <!-- v-for="(value, key, index) in contract"
          :key="`${key}-${index}`"> -->
          
          <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-3">
          </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencieValueBRL as formatValue, formatData } from "@/utils/helpers";

export default {
    name: "HistoricoPagamentos",
     components: {
    },
    data () {
        return {
            loadDeal: false,
            negociacao: null,
            contract :null,
            selectDeal:null,
            digitalLine:null,
            contractFull: null,
            checkSelectAll: false,
            checkContract: false,
            links: [],
        }
    },
    methods: {
        formatValue,
        formatData,

        ...mapActions('minhasDividas', ['ActionDividaNegociar']),

        deactivated() {
            this.divida = null;
            this.negociacao = null;
            this.selectDeal = null;
            this.digitalLine = null;
        },
        voltarNegociar() {
             this.$router.push({ 
               name: 'negociar',
               params: { contracts: this.contractFull },
              });
        },
        showDigitalLine(){
          this.digitalLine = this.selectDeal.linhaDigitavel;
        },

        selectAll() {
              var marcar = document.getElementById('all').checked;
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = marcar;
              }
        },

        select() {
          var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
          var all = document.getElementById('all');
          if(lista.length <= 2) {
            all.checked = false;
          }
        },

        clear() {
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = false;
              }
        },

       /* acordoFechadoParcelas() {
             this.$router.push({ 
               name: 'acordoFechadoParcelas',
               params: { contracts: this.contractFull },
              });
        },*/

         acordoFechado() {
          this.$router.push({ 
            name: 'resumoAcordo',
            params: { parcelado: true },
          });
        },
    },
    async created() {
        this.user.Menus.forEach((menuId) => {
          switch (parseInt(menuId)) {
            case 2:
              this.links.push({
                icon: "",
                text: "Contratos Negociáveis",
                route: "/dashboard/minhas-dividas",
              });
              break;
            case 1:
              this.links.push({
                icon: "",
                text: "Boletos Ativos",
                route: "meusBoletos",
              });
              break;
            case 3:
              this.links.push({
                icon: "",
                text: "Acordos",
                route: "/dashboard/meus-acordos",
              });
              break;
          }
        });
        this.loadDeal = true;
        this.contractFull = this.$route.params.contracts;
        this.contract = this.contractFull[0].environments[0].contracts
        this.loadDeal = false;
    },
    computed: {
      ...mapState("auth", ["user"]),
      isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    }
};
</script>
